import { createSelector } from "reselect";

import { routeIdSelector as customerIdSelector } from "../customer/selectors";
import { CustomerState } from "../customer";

import { EmployeeRecord, AppState, EmployeeRecordsDetail } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params!.employeeRecordId!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
};

export type SelectorState = AppState & CustomerState;

export const employeeRecordsSelector = (state: SelectorState): EmployeeRecordsDetail => {
    const customerId = customerIdSelector(state);
    let employeeRecords = state.employeeRecordsDetail.employeeRecords;

    if (customerId) {
        employeeRecords = employeeRecords.filter(p => p.customerId === customerId);
    }

    return { employeeRecords, tooManyRecords: state.employeeRecordsDetail.tooManyRecords };
};

/**
 * @deprecated replaced by `useEmployeeRecordDetailsModel` hook or `employeeRecord` selector
 */
export const employeeRecordSelector = createSelector(
    employeeRecordsSelector,
    routeIdSelector,
    (employeeRecordsDetail: EmployeeRecordsDetail, id: string) => {
        return (employeeRecordsDetail.employeeRecords.filter(c => c.id === id)[0] || {}) as EmployeeRecord;
    }
);

export const employeeRecord = createSelector(
    employeeRecordsSelector,
    routeIdSelector,
    (employeeRecordsDetail: EmployeeRecordsDetail, id: string) => {
        return employeeRecordsDetail.employeeRecords.find(c => c.id === id);
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname!.substring( // eslint-disable-line @typescript-eslint/no-non-null-assertion
        0,
        state.router.pathname!.indexOf("employeeRecords") + "employeeRecords".length // eslint-disable-line @typescript-eslint/no-non-null-assertion
    );
